import React from 'react';

import { Breadcrumb } from '../../components/Breadcrumb';
import { IconButton } from '../../components/IconButton';

// 既存 public/figma_asset アイコン利用
const iconUserGray = '/figma_asset/UserGray.svg';
const iconSearch = '/figma_asset/Search.svg';
const iconPlus = '/figma_asset/Plus square.svg';

interface UserRow {
  id: string;
  userName: string;
  companyName: string;
  status: string;
  doctor: string;
  questionnairePdf?: boolean;
  diagnosisPdf?: boolean;
  invoicePdf?: boolean;
  totalAmount: string; // 累計請求金額 (未定義なので仮)
  createdAt: string;
  updatedAt: string;
  isNew?: boolean;
}

// 仮データ: Figma スクリーンの状態を再現 (一部簡略化)
const users: UserRow[] = [
  {
    id: 'u1',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'パルス未検査',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u2',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'パルス未検査',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u3',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'CPAP治療中',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u4',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'CPAP治療中',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u5',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'CPAP治療中',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
  },
  {
    id: 'u6',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: '予約未確認',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u7',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'PSG検査中',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
  {
    id: 'u8',
    userName: '鈴木 太郎',
    companyName: 'サカタのタネ株式会社',
    status: 'CPAP治療中',
    doctor: '三崎 宏太',
    questionnairePdf: true,
    diagnosisPdf: true,
    invoicePdf: true,
    totalAmount: '--------',
    createdAt: '2025.08.01',
    updatedAt: '2025.08.05',
    isNew: true,
  },
];

const ListUserPage: React.FC = () => {
  return (
    <div className="flex flex-col w-full gap-[40px]">
      {/* breadcrumb */}
      <Breadcrumb
        items={[
          { label: 'ホーム', href: '/dashboard' },
          { label: '企業リスト' },
          { label: 'サカタのタネ株式会社' },
        ]}
        separator="＜"
        showLeadingSeparator
      />

      {/* タイトル + フィルターグループ (Figma: gap 290px 相当) 中央揃え */}
      <div className="flex w-full items-center gap-[290px]">
        <h1 className="text-[28px] font-medium text-black leading-none flex-shrink-0">
          ユーザー一覧
        </h1>
        <div className="flex flex-col gap-[15px] flex-1">
          {/* 1段目: 企業名 */}
          <div className="flex gap-[5px] w-full">
            <SelectFilter placeholder="企業名" />
            <SearchFilter value="サカタのタネ" ariaLabel="企業検索" />
          </div>
          {/* 2段目: ステータス */}
          <div className="flex gap-[5px] w-full">
            <SelectFilter placeholder="ステータス" />
            <SearchFilter value="パルス未検査" ariaLabel="ステータス検索" />
          </div>
          {/* 3段目: 更新日レンジ */}
          <div className="flex gap-[5px] w-full items-center">
            <SelectFilter placeholder="更新日" />
            <SearchFilter value="2025.08.05" ariaLabel="開始日" />
            <p className="text-[16px] text-black mx-[10px]">〜</p>
            <SearchFilter value="2025.08.05" ariaLabel="終了日" />
          </div>
        </div>
      </div>
      {/* 抽出ボタン行 (右寄せ) */}
      <div className="flex w-full items-center gap-[40px]">
        <div className="flex-1 h-[34px]" />
        <div className="flex items-start gap-[10px]">
          <IconButton
            label="抽出"
            iconSrc={iconPlus}
            iconAlt="抽出"
            iconPosition="left"
            variant="primary"
          />
        </div>
      </div>

      {/* テーブルヘッダー */}
      <div className="bg-white flex items-center gap-[10px] w-full px-[15px] py-[10px] text-[14px]">
        <div className="w-[55px]" />
        <div className="w-[147px]">ユーザー名</div>
        <div className="w-[147px]">企業名</div>
        <div className="w-[147px]">ステータス</div>
        <div className="w-[147px]">担当医師</div>
        <div className="w-[60px]">問診票</div>
        <div className="w-[60px]">診断書</div>
        <div className="w-[54px]">請求書</div>
        <div className="w-[150px]">累計請求金額</div>
        <div className="w-[82px]">作成日</div>
        <div className="w-[72px]">更新日</div>
      </div>

      {/* 行 */}
      <div className="flex flex-col w-full gap-[12px]">
        {users.map((u) => (
          <div
            key={u.id}
            className="bg-white flex items-center gap-[20px] w-full px-[20px] py-[12px] border border-black/20"
          >
            <div className="w-[55px] flex items-center justify-center">
              {u.isNew && <span className="text-[16px] font-bold text-[#ff7a7a]">NEW</span>}
            </div>
            {/* ユーザー名 */}
            <div className="w-[147px] flex items-center gap-[8px] text-[16px]">
              <div className="w-[33px] h-[33px] rounded-[32px] bg-[#5a5a5a] flex items-center justify-center">
                <img src={iconUserGray} alt="user" className="w-[20px] h-[20px]" />
              </div>
              <span>{u.userName}</span>
            </div>
            {/* 企業名 */}
            <div className="w-[147px] text-[16px] truncate">{u.companyName}</div>
            {/* ステータス */}
            <div className="w-[147px]">
              <div className="border border-black rounded-[20px] p-[10px] text-center text-[16px]">
                {u.status}
              </div>
            </div>
            {/* 担当医師 */}
            <div className="w-[147px] flex items-center gap-[8px] text-[16px]">
              <div className="w-[33px] h-[33px] rounded-[32px] bg-[#b3b3b3] flex items-center justify-center">
                <img src={iconUserGray} alt="doctor" className="w-[20px] h-[20px]" />
              </div>
              <span>{u.doctor}</span>
            </div>
            {/* 問診票・診断書・請求書 */}
            <div className="w-[60px] text-[16px] text-[#ff7a7a]">
              {u.questionnairePdf && '＞PDF'}
            </div>
            <div className="w-[60px] text-[16px] text-[#ff7a7a]">{u.diagnosisPdf && '＞PDF'}</div>
            <div className="w-[54px] text-[16px] text-[#ff7a7a]">{u.invoicePdf && '＞PDF'}</div>
            {/* 金額 */}
            <div className="w-[150px] text-[16px]">{u.totalAmount}</div>
            {/* 作成日 / 更新日 */}
            <div className="w-[82px] text-[16px] whitespace-nowrap">{u.createdAt}</div>
            <div className="w-[72px] text-[16px] whitespace-nowrap">{u.updatedAt}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListUserPage;

// ------ 内部コンポーネント: Figma デザイン専用フィルター要素 ------
const baseFilter =
  'flex items-center h-[50px] border border-black rounded-[20px] px-[14px] py-[10px] box-border';

interface SelectFilterProps {
  placeholder: string;
  className?: string;
}

const ChevronDown: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={'w-[20px] h-[20px] ' + className}
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const SelectFilter: React.FC<SelectFilterProps> = ({ placeholder, className }) => (
  <div
    className={`${baseFilter} w-[209px] ${className || ''}`}
    aria-label={`${placeholder}フィルター(選択)`}
  >
    <ChevronDown className="mr-[5px]" />
    <p className="text-[16px] text-black opacity-50">{placeholder}</p>
  </div>
);

interface SearchFilterProps {
  value: string;
  ariaLabel?: string;
  className?: string;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ value, ariaLabel, className }) => (
  <div
    className={`${baseFilter} flex-1 min-w-0 ${className || ''}`}
    aria-label={ariaLabel || `${value}検索`}
  >
    <img src={iconSearch} alt="検索" className="w-[20px] h-[20px] mr-[5px]" />
    <p className="text-[16px] text-black text-center truncate">{value}</p>
  </div>
);
